import { render, staticRenderFns } from "./RecurringEvent.vue?vue&type=template&id=5b993bb9"
import script from "./RecurringEvent.vue?vue&type=script&lang=js"
export * from "./RecurringEvent.vue?vue&type=script&lang=js"
import style0 from "./RecurringEvent.vue?vue&type=style&index=0&id=5b993bb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports